import * as React from 'react'

function SvgClock(props, svgRef) {
  return (
    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M18.1 4.15a9.992 9.992 0 00-2.25-2.25 2.079 2.079 0 112.25 2.25zm.234 5.852a8.302 8.302 0 01-3.217 6.57l1.442 2.292a.738.738 0 01-.308 1.047.88.88 0 01-1.142-.28l-1.367-2.188a8.284 8.284 0 01-7.484 0L4.89 19.631a.88.88 0 01-1.142.28.738.738 0 01-.309-1.047l1.442-2.293a8.334 8.334 0 1113.452-6.569zM10 3.334a6.668 6.668 0 100 13.336 6.668 6.668 0 000-13.336zm.4 8.129l-.675-.683a.824.824 0 01-.559-.778v-2.5a.833.833 0 011.667 0v2.3l.608.612a.742.742 0 01-.008 1.046.726.726 0 01-1.033.003zM1.9 4.15A2.079 2.079 0 114.15 1.9 9.99 9.99 0 001.9 4.15z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgClock)
export default ForwardRef
